import { render, staticRenderFns } from "./forbidden-page.vue?vue&type=template&id=2a318d01"
import script from "./forbidden-page.vue?vue&type=script&lang=ts"
export * from "./forbidden-page.vue?vue&type=script&lang=ts"
import style0 from "./forbidden-page.vue?vue&type=style&index=0&id=2a318d01&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
